var styles = {"favButton":"index-module_favButton__7QmRs"};

export { styles as default };
//# sourceMappingURL=index.module.css.js.map
